import { gql } from '@apollo/client';
import orgsAndUnitsFragment from '../../shared/queries/orgsAndUnitsFragment';

const GET_ORGS_AND_UNITS_FOR_EVENT_COMMENT_REPORT = gql`
  query GetOrgsAndUnitsForEventCommentReport {
    orgsAndUnitsForEventCommentReport {
      ...OrgAndUnitsFields
    }
  }
  ${orgsAndUnitsFragment}
`;

export default GET_ORGS_AND_UNITS_FOR_EVENT_COMMENT_REPORT;
